import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { ComponentProps } from 'react';
import { TextInput } from '@liveauctioneers/hammer-ui-core/textInput';

export type RecalculateInvoicesPayload = {
    invoices: string[];
};

export type ATGPayInvoicePayload = {
    [key: string]: any;
    auction?: {
        id: string;
    };
    salesOrderId: number;
    seller: {
        id: string;
        name?: string;
    };
};

export type ATGPayAuctionSlice =
    | {
          invoiceCache: Record<string, ATGPayInvoicePayload>;
          jwtToken: string | null;
          wasAttempted: false;
      }
    | {
          bidderLink: string;
          catalogId: string;
          invoiceCache: Record<string, ATGPayInvoicePayload>;
          jwtToken: string | null;
          mainhostLink: string;
          rawResponse: any;
          wasAttempted: true;
          wasSuccess: true;
      }
    | {
          errorMessage: string;
          invoiceCache: Record<string, ATGPayInvoicePayload>;
          jwtToken: string | null;
          wasAttempted: true;
          wasSuccess: false;
      };

export const defaultATGPayAuctionSlice: ATGPayAuctionSlice = {
    invoiceCache: {},
    jwtToken: null,
    wasAttempted: false,
};

export type ATGPayAuction = {
    catalogId: string;
    marketplaceCode: string;
};

export type ATGPayAuctionSuccessPayload = {
    auction: string;
    catalogId: string;
    eoaPage: string;
};

export type TextInputOnChange = NonNullable<ComponentProps<typeof TextInput>['onChange']>;
export type CheckboxOnChange = NonNullable<ComponentProps<typeof Checkbox.Option>['onChange']>;
